module.exports = __webpack_public_path__ + "img/eye-low-vision.58a1f186.svg";